import { CostCenterCategoryData } from '../types/types';
import { apiResource } from '../../../common/services/apiClient';

export const costCenterCategoriesApi = apiResource<CostCenterCategoryData>(
	'cost-center-categories'
);
